import React, { useContext, useEffect } from "react";
import AppContext from "@App/context/AppContext";
import { useNavigate } from "react-router-dom";
import { LoginRoute } from "@/routes/auth";

export const Logout = () => {
  const { setLoggedIn, setImpersonatorToken } = useContext(AppContext);
  const navigate = useNavigate();
  useEffect(() => {
    setLoggedIn && setLoggedIn(false);
    setImpersonatorToken && setImpersonatorToken("");
    const keysToDelete = [
      "access_token",
      "auto_login_token",
      "client_id",
      "expires_in",
      "gtmInitialized",
      "jti",
      "refresh_token",
      "scope",
      "token_type",
      "user_id",
      "impersonator_token",
    ];
    keysToDelete.forEach((key) => {
      localStorage.removeItem(key);
    });
    navigate(LoginRoute);

    // eslint-disable-next-line
  }, []);

  return <></>;
};
